<div
  class="card-item-list-item"
  [class.completed]="card().completed"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  tabindex="0"
  role="button"
  [attr.aria-label]="'Open ' + card().header"
>
  <div class="card-item-list-item-inner">
    <div class="card-item-list-item-image">
      <ptl-card-image [src]="card().image" [alt]="card().header" [cardIndex]="cardIndex()"></ptl-card-image>

      <div *ngIf="card().lmsPlatformType" class="card-item-list-item-lms-badge">
        {{ lmsPlatformLabel() }}
        <ptl-icon [icon]="LucideSquareArrowOutUpRight" size="xs"></ptl-icon>
      </div>
    </div>

    <div class="card-item-list-item-content">
      <h3 class="card-item-list-item-title subtitle6">{{ card().header }}</h3>

      @if (cardSubheader()) {
        <p class="card-item-list-item-description">{{ cardSubheader() }}</p>
      }
    </div>

    <div class="progress-spinner-container" [class.disabled]="progress() === 0">
      <mat-progress-spinner
        class="progress-spinner"
        diameter="56"
        [value]="progress()"
        mode="determinate"
        aria-label="Task progress"
      ></mat-progress-spinner>

      <div class="percent-text body-s semibold">{{ progress() }}%</div>
    </div>
  </div>
</div>
